import { render, staticRenderFns } from "./ChildOutstandingFeeReceipts.vue?vue&type=template&id=6ee9c6b4&scoped=true&"
import script from "./ChildOutstandingFeeReceipts.vue?vue&type=script&lang=js&"
export * from "./ChildOutstandingFeeReceipts.vue?vue&type=script&lang=js&"
import style0 from "./ChildOutstandingFeeReceipts.vue?vue&type=style&index=0&id=6ee9c6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee9c6b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VIcon,VOverlay,VProgressCircular,VRow,VSimpleTable,VSpacer,VToolbar,VToolbarTitle})
